import { RoomWithoutIntegration } from "../../../../models";

interface RoomWithoutIntegrationDTO {
  _id: string;
  name: string;
  address: string;
}

export const mapRoomsWithoutIntegration = (
  room: RoomWithoutIntegrationDTO
): RoomWithoutIntegration => {
  return {
    _id: room._id,
    name: room.name,
    address: room.address,
  };
};
